export default __webpack_public_path__ + "static/BannerMyWaySelfCheckAudiApproved-1910effd2c8acacf86f98929bbefa8fd.jpg";